export default {
    setGroups(state, groups) {
        state.groups = groups;
    },
    setChannels(state, channels) {
        state.channels = channels;
    },
    setPinnedRoomIds(state, ids) {
    	state.pinned = ids;
    }
}